export default {
  showAlarms: 'Störungen anzeigen',
  showStages: 'Rezeptschritte anzeigen',
  showMarkers: 'Markierungen anzeigen',
  showHoverPoints: 'Angezeigte Punkte hervorheben',
};
